/* globals getDisplayFactoryList, numberOfDecimals */
(function () {
	'use strict';
	angular.module('app.core')
		.controller('itemDrilldownCtrl', function ($rootScope, $scope, $filter, $timeout, $experiments,
			$location, $http, $window, itemDetailsService, numberFormatService, percentageFormatService,
			integerFormatService, currencyFormatService, slideInModalService, drilldownFunctionsService,
			inventoryActionsService, stockRequirementFiltersService, factorySettingService, itemDetailsPendingRequestsService,
			storeService, supplierPerformanceSummaryService, userAttributes, $translate) {
			$scope.itemCodeDrilldown = true;

			function isIopCampaignsEnabled() {
				return $experiments.isEnabled('iop-campaigns') && !!globalConfig.customer.iopBuyerActionsEnabled;
			}

			function itemHasCampaignFromState(state) {
				var itemCampaign = state.itemDrilldown.itemCampaign;
				return isIopCampaignsEnabled() &&
					itemCampaign &&
					itemCampaign.status === 'loaded' &&
					itemCampaign.summary != null;
			}

			function refreshCampaignActionsTabVisibility(state) {
				$scope.showCampaignActionsTab = itemHasCampaignFromState(state || storeService.getState());
			}

			$scope.showCampaignActionsTab = false;
			$scope.activeTab = 'supplyAndDemand';
			$scope.tab = {
				activeTabIndex: 1
			};
			$scope.pendingCampaignDefaultTab = false;
			$scope.actionsSidebarOpen = false;
			$scope.chatSidebarOpen = false;
			$scope.addColumnSidebarOpen = false;
			$scope.showSupplyAndDemandDownload = false;
			$scope.showCampaignPoActionsDownload = false;
			var search = $location.search();
			var timeouts = {};
			$scope.display = {};
			$scope.showAddTask = true;
			$scope.isFullscreen = ($location.url()).indexOf('/item-drilldown') !== -1;
			$scope.getWeeklyRequirementReportDrilldownUrl = getWeeklyRequirementReportDrilldownUrl;
			$scope.getPastRequirementsReportDrilldownUrl = getPastRequirementsReportDrilldownUrl;
			$scope.getInventoryDrilldownUrl = getInventoryDrilldownUrl;
			$scope.getPurchaseOrderReceiptsDrilldownUrl = getPurchaseOrderReceiptsDrilldownUrl;
			$scope.getSupplyOrdersDrilldownUrl = getSupplyOrdersDrilldownUrl;
			$scope.showCompanyDemandDrilldown = true;
			$scope.isCompanyDemandPast = false;
			$scope.useGreaterOfPastOrFuture = false;
			$scope.showItemSearchItemDrilldown = !!userAttributes.get('showItemSearchItemDrilldown');
			var w = angular.element($window);

			var itemCode = search ? search.itemCode : '';
			var itemType = search ? search.itemType : '';
			var inventoryActionType = search ? search.inventoryActionType : '';
			$scope.incomingLocation = search && search.insidePanel ?
				'My Assignments - ' + (search.inventoryActionType ? 'Inventory Actions': 'Procurement Task') : 'Email';
			$scope.insidePanel = search ? search.insidePanel : false;
			$scope.mrpTabReady = false;
			var currencySymbol;
			var opened = false;
			var useRootCauseDateInHistory = false;

			$scope.numberOfTasks = 0;
			$scope.itemFlexFields = [];
			$scope.itemFlexFieldRows = [];
			var unsubscribe;
			unsubscribe = storeService.subscribe(function () {
				var state = storeService.getState();
				if (state.previousAction.type === 'modal/openModal') {
					if (state.previousAction.payload.modalType === 'itemDrilldown') {
						setTimeout(function() {
							if (state.previousAction.payload.modalParams.fromInlineSearch) {
								reloadNewItemDrilldown(state.previousAction.payload.modalParams);
							} else {
								openItemDrilldownCallback(state.previousAction.payload.modalParams);
							}
						}, 0);
					} else if (state.previousAction.payload.modalType === 'supplierScoreCard') {
						setTimeout(function() {
							supplierPerformanceSummaryService.openSupplierScoreCard(state.previousAction.payload.modalParams);
						}, 0);
					} else if (state.previousAction.payload.modalType === 'confirmationShipments') {
						// Close item drilldown so the parent report's ConfirmationShipmentsDrawer can show.
						// Pass isInitialClose=true so itemDrilldownClosed does not clear the Redux modal
						// we just opened for confirmationShipments.
						setTimeout(function() {
							slideInModalService.closeModal(true);
						}, 0);
					}
				}

				var itemEntityId = 'factoryNdx=' + $scope.drilldownFactoryNdx + '&itemCode=' + $scope.itemCode;
				var item = state.items.entities[itemEntityId];
				if (item) {
					var count = 0;
					item.taskIds.forEach(function (taskId) {
						var procTask = state.procurementTasks && state.procurementTasks.entities[taskId];
						if (procTask && (procTask.statusName === 'Open' || procTask.statusName === 'Review Later') && procTask.active) {
							count++;
						}
					});
					$scope.numberOfTasks = count;
				};
				var currentlyOpenedTab = state.itemDrilldown.currentlyOpenedTab;
				var isTabChanged = state.previousAction.type === 'itemDrilldown/setCurrentlyOpenedTab';
				if (isTabChanged && currentlyOpenedTab && $scope.activeTab !== currentlyOpenedTab) {
					$timeout(function () {
						$scope.selectTab(currentlyOpenedTab, undefined, undefined);
					}, 0);

				}

				if (state.itemDrilldown.supplyAndDemandFilterActive) {
					jQuery('li.stock-tab.active').addClass('hide-tab-selection');
				} else {
					jQuery('li.stock-tab.active').removeClass('hide-tab-selection');
				}

				if (state.previousAction.type === 'global-config/save-user-attribute/pending') {
					if (state.previousAction.meta.arg.attributes.showItemSearchItemDrilldown != null) {
						$timeout(function () {	
							$scope.showItemSearchItemDrilldown = !!state.previousAction.meta.arg.attributes.showItemSearchItemDrilldown;
						}, 0);
					}

				}

				if ($scope.actionsSidebarOpen !== state.itemDrilldown.actionsSidebarOpen) {
					$timeout(function () {
						$scope.actionsSidebarOpen = state.itemDrilldown.actionsSidebarOpen;
					}, 0);
				}

				if ($scope.chatSidebarOpen !== state.chat.isChatOpened) {
					$timeout(function () {
						$scope.chatSidebarOpen = state.chat.isChatOpened;
					}, 0);
				}

				if ($scope.addColumnSidebarOpen !== state.columnDrawerReducer.isOpen) {
					$timeout(function () {
						$scope.addColumnSidebarOpen = state.columnDrawerReducer.isOpen;
					}, 0);
				}

				if ($scope.showSupplyAndDemandDownload !== state.itemDrilldown.exportSupplyAndDemandReport) {
					$timeout(function () {
						$scope.showSupplyAndDemandDownload = state.itemDrilldown.exportSupplyAndDemandReport;
					}, 0);
				}

				if ($scope.showCampaignPoActionsDownload !== state.itemDrilldown.exportCampaignPoActionsReport) {
					$timeout(function () {
						$scope.showCampaignPoActionsDownload = state.itemDrilldown.exportCampaignPoActionsReport;
					}, 0);
				}

				var campaignItemActionTypes = [
					'itemDrilldown/fetchItemCampaignSummary/pending',
					'itemDrilldown/fetchItemCampaignSummary/fulfilled',
					'itemDrilldown/fetchItemCampaignSummary/rejected',
					'itemDrilldown/resetItemCampaign'
				];
				if (campaignItemActionTypes.indexOf(state.previousAction.type) !== -1) {
					$timeout(function () {
						refreshCampaignActionsTabVisibility(state);
						if (!$scope.showCampaignActionsTab && $scope.activeTab === 'campaign-actions') {
							$scope.selectTab('supplyAndDemand', false);
						} else if (
							$scope.showCampaignActionsTab &&
							$scope.pendingCampaignDefaultTab &&
							$scope.activeTab === 'supplyAndDemand'
						) {
							$scope.selectTab('campaign-actions', false);
							$scope.pendingCampaignDefaultTab = false;
						}
					}, 0);
				}
			});

			if (typeof itemType !== 'undefined' && itemType === 'Manufactured') {
				$scope.itemType = itemType;
				$scope.isManufacturedItem = true;
			} else {
				$scope.itemType = undefined;
				$scope.isManufacturedItem = false;
			}
			var procureRptNdx = search ? search.procureRptNdx : '';

			if (search.actionId) {
				// A specific IA task is being requested
				$scope.specificTaskType = 'action';
				$scope.specificTaskId = parseInt(search.actionId);
				$scope.currentTaskId = parseInt(search.currentTaskId);
			} else if (search.taskId) {
				// A specific user task is being requested
				$scope.specificTaskType = 'task';
				$scope.specificTaskId = parseInt(search.taskId);
				$scope.currentTaskId = parseInt(search.currentTaskId);
			}

			$scope.siteId = search && search.factoryNdx && globalConfig.user.authFacts[search.factoryNdx] ? search.factoryNdx : globalConfig.factory.id;
			if ($scope.siteId !== globalConfig.factory.id) {
				$scope.factoryList = getDisplayFactoryList([$scope.siteId]);
				$scope.selectedFactory = $scope.factoryList[0];
			}
			currencySymbol = globalConfig.user.authFacts[$scope.siteId].currencySymbol;
			if ($scope.insidePanel) {
				$scope.factoryList = getDisplayFactoryList($scope.siteId.toString().split(','));
				$scope.selectedFactory = $scope.factoryList[0];
			}
			//TODO fix this correctly to differentiate between slide in and pop out
			if ($scope.displayTabs && $scope.displayTabs.active !== 'supplyChain' &&
				$scope.displayTabs.active !== 'myTasks') {
				$scope.displayTabs.active = 'true';
			}
			if ($scope.specificTaskType === 'action' && inventoryActionType === 'Excess to Sell') {
				$scope.sortMultitenantByExcessToSell = true;
				search.defaultTab = 'multitenantSection';
			} else {
				$scope.sortMultitenantByExcessToSell = false;
			}
			$scope.showForwardDemandDOI = globalConfig.user.authFacts[$scope.siteId].settings.UseForwardOnlyDemandForForwardDOI === '1' || globalConfig.user.authFacts[$scope.siteId].settings.UseForwardOnlyDemandForForwardDOI === 1;

			$scope.tabMap = {
				'opportunitiesSection': 'stock',
				'taskSection': 'stock',
				'stockSection': 'stock',
				'supplyAndDemandSection': 'supplyAndDemand',
				'masterSection': 'master',
				'deliveriesSection': 'deliveries',
				'historicalSection': 'historical-purchasing',
				'multitenantSection': 'material-information',
				'manufacturedInventoryHistoricalSection': 'manufactured-item',
				'alternateItemsSection': 'alternate-item',
				'other-projects': 'other-projects'
			};

			$scope.tabIndexMap = {
				'campaign-actions': 0,
				'supplyAndDemand': 1,
				'stock': 1,
				'master': 2,
				'deliveries': 3,
				'historical-purchasing': 4,
				'material-information': 5,
				'alternate-item': 6,
				'manufactured-item': 7,
				'action-history': 8,
				'other-projects': 9
			};
			$scope.isDrillDownModal = false;
			$scope.undefinedEmail = 'UndefinedEmail';
			$scope.undefinedPoc = 'UndefinedPoc';
			$scope.undefinedPhone = 'UndefinedTelephone';
			$scope.undefinedPlanner = 'UndefinedPlanner';
			$scope.undefinedBuyer = ['UndefinedBuyer', 'UnassignedBuyer'];
			$scope.loadingOrderData = true;
			$scope.loadingMasterSection = true;
			$scope.loadingDeliveriesSection = true;
			$scope.loadingHistoricalSection = true;
			$scope.loadingMultitenantSection = true;
			$scope.loadingMultiprojectSection = true;
			$scope.loadingManufacturedHistoricalSection = true;
			$scope.loadingAlternateItemSection = true;
			$scope.loadingActionHistorySection = true;
			$scope.factoryDisplayList = [];

			$scope.enableDrilldowns = $scope.siteId == globalConfig.factory.id.toString();
			$scope.drilldownFactoryNdx = $scope.siteId;
			stockRequirementFiltersService.clearData(itemCode, $scope.drilldownFactoryNdx);

			function setDescriptiveHelpState() {
				$scope.descriptiveHelp = {
					targetQty: true,
					avgDailyDemand: true,
					oneYearRequirement: true,
					averageMonthlyUsage: true,
					pastDemand: true,
					futureDemand: true,
					forwardDemandDOI: true,
					lastPoPrice: true,
					standardPrice: true,
					movingAvgPrice: true,
					onHandValue: true,
					leadTimeMultiple: true,
					otherSites: {
						oneYearRequirement: true,
						avgDailyDemand: true,
						movingAvgPrice: true
					}
				};
			}

			function getDeliveriesSection() {
				if (!$scope.loadActualPo) {
					getActualPo();
				}
			}

			function getHistoricalSection() {
				if (!$scope.loadHistorical) {
					getHistorical();
				}
			}

			function getAlternateItemSection() {
				if (!$scope.loadAlternateItems) {
					getAlternateItems();
				}
			}

			function formatItemFlexFieldValue(storageType, value) {
				if (value === 0 || value === '0' || value == null) {
					if (storageType === 'currency' || storageType === 'number' || storageType === 'integer') {
						return '';
					}
				}
				if (storageType === 'currency') {
					return currencyFormatService.getWithParameters(value, numberOfDecimals(value, 2), currencySymbol);
				}
				if (storageType === 'integer') {
					return integerFormatService.getWithParameters(value, 0);
				}
				if (storageType === 'number') {
					return numberFormatService.getWithParameters(value, numberOfDecimals(value));
				}
				return value;
			}

			function buildItemFlexFields() {
				var fields = [];
				_.each(globalConfig.customer.flexFields || {}, function (field, fieldName) {
					if (field.sourceType === 'item') {
						fields.push({
							key: fieldName,
							displayName: field.displayName,
							storageType: field.storageType,
							description: field.description && field.description !== field.displayName ? field.description : '',
							columnOrder: field.columnOrder,
							displayValue: formatItemFlexFieldValue(field.storageType, $scope.itemMasterData[fieldName])
						});
					}
				});
				fields = _.sortBy(fields, 'columnOrder');
				$scope.itemFlexFields = fields;
				$scope.itemFlexFieldRows = [];
				for (var i = 0; i < fields.length; i += 2) {
					$scope.itemFlexFieldRows.push(fields.slice(i, i + 2));
				}
			}

			function populateAndFormatViewVariables() {
				var decimals;
				var keepDecimals;
				$scope.projInventoryChangesQuantityFloat = -1 * $scope.itemMasterData.projInventoryChangesFloat /
					$scope.itemMasterData.costPerItemFloat;
				$scope.projInventoryChangesQuantityFloat =
					integerFormatService.getWithParameters($scope.projInventoryChangesQuantityFloat, 2);

				$scope.itemMasterData.projInventoryChangesFloat = $scope.itemMasterData.projInventoryChangesFloat * -1;
				$scope.itemMasterData.showPotentialSavings = $scope.itemMasterData.projInventoryChangesFloat > 0;
				$scope.itemMasterData.projInventoryChangesFloat =
					currencyFormatService.getWithParameters($scope.itemMasterData.projInventoryChangesFloat, 0, currencySymbol);

				//Item Master Data section
				$scope.itemMasterData.fixedOrderQuantityDaysCoverage = 0;
				$scope.itemMasterData.reorderPointDaysCoverage = 0;
				$scope.itemMasterData.minOQDaysCoverage = 0;
				$scope.itemMasterData.orderMultDaysCoverage = 0;
				$scope.itemMasterData.totalOHQDaysCoverage = 0;
				$scope.itemMasterData.totalOHUnrestrictedDaysCoverage = 0;
				$scope.safetyFactoryInDaysFloat = 0;
				if ($scope.itemMasterData.analysisAvgDailyDemandFloat > 0) {
					$scope.itemMasterData.fixedOrderQuantityDaysCoverage =
						$scope.itemMasterData.fixedOrderQuantityFloat / $scope.itemMasterData.analysisAvgDailyDemandFloat;
					$scope.itemMasterData.reorderPointDaysCoverage =
						$scope.itemMasterData.reorderPointFloat / $scope.itemMasterData.analysisAvgDailyDemandFloat;
					$scope.itemMasterData.minOQDaysCoverage =
						$scope.itemMasterData.minimumOrderQuantityFloat / $scope.itemMasterData.analysisAvgDailyDemandFloat;
					$scope.itemMasterData.orderMultDaysCoverage =
						$scope.itemMasterData.orderMultipleFloat / $scope.itemMasterData.analysisAvgDailyDemandFloat;
					$scope.itemMasterData.totalOHQDaysCoverage =
						$scope.itemMasterData.totalOnHandQuantityFloat / $scope.itemMasterData.analysisAvgDailyDemandFloat;
					$scope.itemMasterData.totalOHUnrestrictedDaysCoverage =
						$scope.itemMasterData.totalOnHandUnrestrictedQuantity / $scope.itemMasterData.analysisAvgDailyDemandFloat;
					$scope.safetyFactoryInDaysFloat =
						$scope.analysisSafetyStockLevelFloat / $scope.itemMasterData.analysisAvgDailyDemandFloat;
				}
				$scope.itemMasterData.rawAverageDailyDemandFromFutureRqmts = $scope.itemMasterData.averageDailyDemandFromFutureRqmts;
				$scope.itemMasterData.rawAverageDailyDemandFromPastRqmts = $scope.itemMasterData.averageDailyDemandFromPastRqmts;
				$scope.itemMasterData.rawFutureDemandForForwardDOI = $scope.itemMasterData.futureDemandForForwardDOI;
				$scope.showDaysCoverageForMinOQ = $scope.itemMasterData.analysisAvgDailyDemandFloat > 0 &&
					$scope.itemMasterData.minimumOrderQuantityFloat > 1;
				$scope.showDaysCoverageForOrderMult = $scope.itemMasterData.analysisAvgDailyDemandFloat > 0 &&
					$scope.itemMasterData.orderMultipleFloat > 1;
				$scope.showDaysCoverageForTotalOHQ = $scope.itemMasterData.analysisAvgDailyDemandFloat > 0;
				$scope.showDaysCoverageForTotalOHUnrestricted = $scope.itemMasterData.totalOnHandUnrestrictedQuantity > 0;
				$scope.showAlias = $scope.itemMasterData.code !== $scope.itemMasterData.alias &&
					$scope.itemMasterData.code.length > 0 && $scope.itemMasterData.alias !== '-' && $scope.itemMasterData.alias !== 'UndefinedAlias';

				$scope.showSupplierEmail = $scope.itemMasterData.supplierEmail &&
					$scope.itemMasterData.supplierEmail.length > 0 &&
					$scope.itemMasterData.supplierEmail !== $scope.undefinedEmail;
				$scope.monthlyAvgDemand = getMonthlyDemand($scope.itemMasterData.analysisAvgDailyDemandFloat);
				$scope.monthlyPastDemand = getMonthlyDemand($scope.itemMasterData.averageDailyDemandFromPastRqmts);
				$scope.monthlyFutureDemand = getMonthlyDemand($scope.itemMasterData.averageDailyDemandFromFutureRqmts);
				$scope.monthlyForwardDemandDOI = getMonthlyDemand($scope.itemMasterData.futureDemandForForwardDOI);
				$scope.itemMasterData.analysisAvgDailyDemandFloat =
				numberFormatService.getWithParameters($scope.itemMasterData.analysisAvgDailyDemandFloat, 2);
				$scope.itemMasterData.averageDailyDemandFromPastRqmts =
					numberFormatService.getWithParameters($scope.itemMasterData.averageDailyDemandFromPastRqmts, 2);
				$scope.itemMasterData.averageDailyDemandFromFutureRqmts =
					numberFormatService.getWithParameters($scope.itemMasterData.averageDailyDemandFromFutureRqmts, 2);
				$scope.itemMasterData.futureDemandForForwardDOI =
					numberFormatService.getWithParameters($scope.itemMasterData.futureDemandForForwardDOI, 2);
				$scope.itemMasterData.analysisVariabilityFloat =
					percentageFormatService.getWithParameters($scope.itemMasterData.analysisVariabilityFloat * 100);
				$scope.itemMasterData.analysisTotalAnnualDemand =
					numberFormatService.getWithParameters($scope.itemMasterData.analysisTotalAnnualDemand, numberOfDecimals($scope.itemMasterData.analysisTotalAnnualDemand));
				$scope.showHistoricalUsage = $scope.itemMasterData.averageMonthlyUsage > 0;
				decimals = numberOfDecimals($scope.itemMasterData.quotedPrice , 2);
				keepDecimals = numberOfDecimals($scope.itemMasterData.standardPrice, 2, true);
				$scope.itemMasterData.quotedPriceWithDecimals = currencyFormatService.getWithParameters($scope.itemMasterData.quotedPrice, keepDecimals, currencySymbol);
				$scope.itemMasterData.quotedPrice = $scope.itemMasterData.quotedPrice > 0 ?
					currencyFormatService.getWithParameters($scope.itemMasterData.quotedPrice, decimals, currencySymbol) : '';
				decimals = numberOfDecimals($scope.itemMasterData.standardPrice, 2);
				$scope.itemMasterData.standardPriceWithDecimals = currencyFormatService.getWithParameters($scope.itemMasterData.standardPrice, keepDecimals, currencySymbol);
				$scope.itemMasterData.standardPrice = currencyFormatService.getWithParameters(
					$scope.itemMasterData.standardPrice, decimals, currencySymbol);
				decimals = numberOfDecimals($scope.itemMasterData.costPerItemFloat, 2);
				$scope.itemMasterData.costPerItemFloatWithDecimals = currencyFormatService.getWithParameters(
					$scope.itemMasterData.costPerItemFloat, keepDecimals, currencySymbol);
				$scope.itemMasterData.costPerItemFloat = currencyFormatService.getWithParameters(
					$scope.itemMasterData.costPerItemFloat, decimals, currencySymbol);
				$scope.itemMasterData.manufacturedUnitPrice = currencyFormatService.getWithParameters($scope.itemMasterData.manufacturedUnitPrice, decimals, currencySymbol);

				$scope.showMinMax = $scope.itemMasterData.orderPolicy === 'MinMax';
				$scope.showProposedMinMax = $scope.itemMasterData.minLevelFloat !== $scope.itemMasterData.calculatedMinLevel
					|| $scope.itemMasterData.maxLevelFloat !== $scope.itemMasterData.calculatedMaxLevel;
				$scope.showReorderPoint = $scope.itemMasterData.orderPolicy === 'ReOrder Point';

				$scope.showDaysCoverage = $scope.itemMasterData.analysisAvgDailyDemandFloat > 0 &&
					$scope.itemMasterData.reorderPointDaysCoverage > 1;
				$scope.showDaysCoverageForFixedOrderQuantity = $scope.itemMasterData.fixedOrderQuantityDaysCoverage > 0 &&
					$scope.itemMasterData.fixedOrderQuantityFloat > 1;
				$scope.hasValidReorderDate = $scope.itemMasterData.reorderPointEffectiveDate !== 21600000 &&
					$scope.itemMasterData.reorderPointEffectiveDate !== 0 &&
					new Date($scope.itemMasterData.reorderPointEffectiveDate);
				var reorderDate = new Date($scope.itemMasterData.reorderPointEffectiveDate);
				$scope.isCalculatedReorderPointDifferent = (!isNaN(reorderDate.getTime()) &&
					reorderDate.toISOString().slice(0, 10) !== $scope.itemMasterData.analysisReorderPointEffectiveDate);
				$scope.hasValidCalculatedReorderDate = $scope.itemMasterData.analysisReorderPointEffectiveDate !== '1970-01-01';
				$scope.itemMasterData.reorderPointEffectiveDate = $filter('date')(new Date($scope.itemMasterData.reorderPointEffectiveDate), 'mediumDate', 'UTC');
				$scope.itemMasterData.fixedOrderQuantityDaysCoverage =
					integerFormatService.getWithParameters($scope.itemMasterData.fixedOrderQuantityDaysCoverage, 0);
				$scope.itemMasterData.minOQDaysCoverage = integerFormatService.getWithParameters(
					$scope.itemMasterData.minOQDaysCoverage, 0);
				$scope.itemMasterData.orderMultDaysCoverage = integerFormatService.getWithParameters(
					$scope.itemMasterData.orderMultDaysCoverage, 0);
				$scope.itemMasterData.totalOHQDaysCoverage = integerFormatService.getWithParameters(
					$scope.itemMasterData.totalOHQDaysCoverage, 0);
				$scope.itemMasterData.totalOHUnrestrictedDaysCoverage = integerFormatService.getWithParameters(
					$scope.itemMasterData.totalOHUnrestrictedDaysCoverage, 0);
				$scope.itemMasterData.reorderPointDaysCoverage = integerFormatService.getWithParameters(
					$scope.itemMasterData.reorderPointDaysCoverage, 0);

				$scope.itemMasterData.materialGroup = $scope.itemMasterData.materialGroup && $scope.itemMasterData.materialGroup !== 'UndefinedMaterialGroup'? $scope.itemMasterData.materialGroup : '--';
				buildItemFlexFields();
				//END Item Master Data section

				//Analysis Section
				$scope.itemMasterData.currentOnHandCostFloat =
					currencyFormatService.getWithParameters($scope.itemMasterData.currentOnHandCostFloat, 2, currencySymbol);

				if ($scope.itemMasterData.availableDate) {
					$scope.itemMasterData.availableDate = $filter('date')(new Date($scope.itemMasterData.availableDate), 'mediumDate', 'UTC');
				}
				$scope.itemMasterData.analysisTargetInventoryQtyUnformatted = $scope.itemMasterData.analysisTargetInventoryQty;
				$scope.itemMasterData.analysisTargetInventoryQty = numberFormatService.getWithParameters(
					$scope.itemMasterData.analysisTargetInventoryQty, numberOfDecimals($scope.itemMasterData.analysisTargetInventoryQty));
				$scope.itemMasterData.safetyTimeFloat = numberFormatService.getWithParameters(
					$scope.itemMasterData.safetyTimeFloat, numberOfDecimals($scope.itemMasterData.safetyTimeFloat));
				$scope.itemMasterData.analysisExcessOnHandOverLTQty = numberFormatService.getWithParameters(
					$scope.itemMasterData.analysisExcessOnHandOverLTQty, numberOfDecimals($scope.itemMasterData.analysisExcessOnHandOverLTQty));
				$scope.safetyFactoryInDaysFloat =
					integerFormatService.getWithParameters(parseFloat($scope.safetyFactoryInDaysFloat), 0);
				$scope.itemMasterData.analysisSafetyStockLevelFloat = numberFormatService.getWithParameters(
					$scope.itemMasterData.analysisSafetyStockLevelFloat, numberOfDecimals($scope.itemMasterData.analysisSafetyStockLevelFloat));
				$scope.safetyStockText = numberFormatService.getWithParameters(
					$scope.itemMasterData.safetyStockTotal, numberOfDecimals($scope.itemMasterData.safetyStockTotal)) + ' ' + $scope.itemMasterData.uom;

				if (typeof $scope.itemMasterData.analysisSafetyStockLevelFloat !== 'undefined') {
					$scope.safetyStockText += ' (Proposed: ' + $scope.itemMasterData.analysisSafetyStockLevelFloat +
						' ' + $scope.itemMasterData.uom + ')';
				}

				$scope.safetyTime = $scope.itemMasterData.safetyTimeFloat ? $scope.itemMasterData.safetyTimeFloat + ' Days' : '0';
				$scope.safetyStockQuantity = numberFormatService.getWithParameters($scope.itemMasterData.safetyStockFloat,
					numberOfDecimals($scope.itemMasterData.safetStockFloat)) + ' ' + $scope.itemMasterData.uom;

				$scope.itemMasterData.totalOnOrderQuantityFloatDisplay = addDecimalIfNeeded(
					$scope.itemMasterData.totalOnOrderQuantityFloat);
				$scope.itemMasterData.totalOnHandQuantityFloatDisplayUnformatted = $scope.itemMasterData.totalOnHandQuantityFloatDisplay;
				$scope.itemMasterData.totalOnHandQuantityFloatDisplay = addDecimalIfNeeded(
					$scope.itemMasterData.totalOnHandQuantityFloat);
				$scope.itemMasterData.totalOnHandUnrestrictedQuantityDisplay = addDecimalIfNeeded(
					$scope.itemMasterData.totalOnHandUnrestrictedQuantity);
				$scope.itemMasterData.totalOnHandBlockedQuantityFloat =
					$scope.itemMasterData.totalOnHandQuantityFloat - $scope.itemMasterData.totalOnHandUnrestrictedQuantity;
				$scope.itemMasterData.fixedOrderQuantityFloatDisplay = integerFormatService.getWithParameters(
					$scope.itemMasterData.fixedOrderQuantityFloat, 0);
				$scope.itemMasterData.totalOnHandBlockedQuantityFloatDisplay =
					numberFormatService.getWithParameters($scope.itemMasterData.totalOnHandBlockedQuantityFloat, numberOfDecimals($scope.itemMasterData.totalOnHandBlockedQuantityFloat));

				$scope.itemMasterData.totalOnHandUnrestrictedConsignmentQuantityDisplay = addDecimalIfNeeded(
					$scope.itemMasterData.totalOnHandUnrestrictedConsignmentQuantity);
				$scope.itemMasterData.totalOnHandBlockedConsignmentQuantityFloat =
					$scope.itemMasterData.totalOnHandConsignmentQuantity - $scope.itemMasterData.totalOnHandUnrestrictedConsignmentQuantity;
				$scope.itemMasterData.totalOnHandBlockedConsignmentDisplay = addDecimalIfNeeded(
					$scope.itemMasterData.totalOnHandBlockedConsignmentQuantityFloat);

				$scope.itemMasterData.orderMultipleFloatDisplay = integerFormatService.getWithParameters(
					$scope.itemMasterData.orderMultipleFloat, 0);
				$scope.itemMasterData.minimumOrderQuantityFloatDisplay = integerFormatService.getWithParameters(
					$scope.itemMasterData.minimumOrderQuantityFloat, 0);

				$scope.analysisSection = ($scope.itemMasterData.analysisTargetInventoryQty ||
					$scope.itemMasterData.totalOnHandQuantityFloatDisplay);
				//END Analysis Section

			}

			function getMonthlyDemand(demandValue) {
				return numberFormatService.getWithParameters(demandValue * 22, 2);
			}

			function formatDeliveriesList() {
				angular.forEach($scope.actualPo, function (row) {
					row.actualReceiptDate = $filter('date')(new Date(row.actualReceiptDate), 'mediumDate', 'UTC');
					var decimals = 2;
					decimals = Math.max(numberOfDecimals(row.totalAmount, 2, true), 2);
					row.totalAmount = currencyFormatService.getWithParameters(row.totalAmount, decimals, currencySymbol);
					row.receivedQuantityFloat = numberFormatService.getWithParameters(row.receivedQuantityFloat, 0);
					decimals = Math.max(numberOfDecimals(row.unitPriceFloat, 2, true), 2);
					row.unitPriceFloat = currencyFormatService.getWithParameters(row.unitPriceFloat, decimals, currencySymbol);
				});
			}

			function formatHistoricalList() {
				var showDemandInMonths = false;
				angular.forEach($scope.historical, function (row) {
					if (row.analysisAvgDailyDemandFloat < 10) {
						showDemandInMonths = true;
					}
				});
				angular.forEach($scope.historical, function (row) {
					row.dateLog = $filter('date')(new Date(row.dateLog), 'mediumDate', 'UTC');
					var decimals = 2;
					decimals = Math.max(numberOfDecimals(row.costPerItemFloat, 2, true), 2);
					row.costPerItemFloat = currencyFormatService.getWithParameters(row.costPerItemFloat, decimals, currencySymbol);
					decimals = numberOfDecimals(row.quotedPrice, 2);
					row.quotedPrice = currencyFormatService.getWithParameters(row.quotedPrice, decimals, currencySymbol);
					row.demandDisplay = '';

					if (row.analysisAvgDailyDemandFloat === 0) {
						row.demandDisplay = 0;
					} else if (showDemandInMonths) {
						row.demandDisplay =
							numberFormatService.getWithParameters(row.analysisAvgDailyDemandFloat * 22, 2) + ' ' + row.itemuom + '/Month';
					} else {
						row.demandDisplay =
							numberFormatService.getWithParameters(row.analysisAvgDailyDemandFloat, 2) + ' ' + row.itemuom + '/Day';
					}
					row.minLevelFloat = integerFormatService.getWithParameters(row.minLevelFloat, 0);
					row.maxLevelFloat = integerFormatService.getWithParameters(row.maxLevelFloat, 0);
					if (row.reorderPointFloat === 0) {
						row.reorderPointFloat = '';
					} else {
						row.reorderPointFloat = integerFormatService.getWithParameters(row.reorderPointFloat, 0);
					}
					row.totalOnHandQuantityFloat = integerFormatService.getWithParameters(row.totalOnHandQuantityFloat, 0);
					row.totalOnOrderQuantityFloat = integerFormatService.getWithParameters(row.totalOnOrderQuantityFloat, 0);
					row.analysisExcessOnHandCostFloat = currencyFormatService.getWithParameters(row.analysisExcessOnHandCostFloat, 0, currencySymbol);
					row.analysisExcessOnHandQuantityFloat =
						integerFormatService.getWithParameters(row.analysisExcessOnHandQuantityFloat, 0);
					row.aggregateRiskScore = integerFormatService.getWithParameters(row.aggregateRiskScore, 0);
				});
			}

			function formatManufacturedHistoricalList() {
				angular.forEach($scope.historicalManufacturedData, function (row) {
					row.dateLog = $filter('date')(new Date(row.dateLog), 'mediumDate', 'UTC');
					row.value = currencyFormatService.getWithParameters(row.value, 0, currencySymbol);
				});
			}

			function formatMultitenantList(multitenantData, currencyBySite, localCostPerItem) {
				angular.forEach(multitenantData, function (row) {
					if (typeof currencyBySite !== 'undefined' && currencyBySite[row.leanDirFactoryNdx]) {
						row.costPerItemFloat = currencyFormatService.getWithParameters(row.costPerItemFloat, numberOfDecimals(row.costPerItemFloat), currencyBySite[row.leanDirFactoryNdx]);
					} else {
						row.costPerItemFloat = currencyFormatService.getWithParameters(row.costPerItemFloat, numberOfDecimals(row.costPerItemFloat), currencySymbol);
					}
					if (row.daysDisplayType !== 'Calendar Days') {
						row.leadTimeInDaysFloatDisplay = integerFormatService.getWithParameters(row.leadTimeInDaysFloat / 7 * 5, 0) + ' Work Days';
					} else {
						row.leadTimeInDaysFloatDisplay = integerFormatService.getWithParameters(row.leadTimeInDaysFloat, 0);
					}
					row.totalOnHandBlockedQuantityFloat = row.totalOnHandQuantityFloat - row.totalOnHandUnrestrictedQuantity;
					row.totalOnHandBlockedConsignmentQuantityFloat = (row.totalOnHandConsignmentQuantity || 0) - (row.totalOnHandUnrestrictedConsignmentQuantity || 0);

					
					row.analysisAvgDailyDemand = numberFormatService.getWithParameters(row.analysisAvgDailyDemandFloat, 2) + ' ' + row.uom + ' / Day';
					row.averageDailyDemandFromPastRqmts = numberFormatService.getWithParameters(row.averageDailyDemandFromPastRqmts, 2) + ' ' + row.uom + ' / Day';
					row.averageDailyDemandFromFutureRqmts = numberFormatService.getWithParameters(row.averageDailyDemandFromFutureRqmts, 2) + ' ' + row.uom + ' / Day';
					row.futureDemandForForwardDOI = numberFormatService.getWithParameters(row.futureDemandForForwardDOI, 2) + ' ' + row.uom + ' / Day';
					row.totalOnHandUnrestrictedQuantity = integerFormatService.getWithParameters(row.totalOnHandUnrestrictedQuantity, 0);
					row.totalOnHandBlockedQuantityFloat = integerFormatService.getWithParameters(row.totalOnHandBlockedQuantityFloat, 0);
					row.totalOnHandUnrestrictedConsignmentQuantity = integerFormatService.getWithParameters(row.totalOnHandUnrestrictedConsignmentQuantity || 0, 0);
					row.totalOnHandBlockedConsignmentQuantity = integerFormatService.getWithParameters(row.totalOnHandBlockedConsignmentQuantityFloat, 0);
					row.totalOnOrderQuantityFloat = integerFormatService.getWithParameters(row.totalOnOrderQuantityFloat, 0);
					row.minimumOrderQuantityFloat = integerFormatService.getWithParameters(row.minimumOrderQuantityFloat, 0);
					row.orderMultipleFloat = integerFormatService.getWithParameters(row.orderMultipleFloat, 0);
					row.analysisExcessOnHandOverLTQty = numberFormatService.getWithParameters(row.excessOverLtMultiple, numberOfDecimals(row.excessOverLtMultiple));
					row.erpOrderPolicy = row.erpOrderPolicy + ' (' + (row.erpOrderPolicy == 'MinMax' ? 'Min-' + row.minLevelFloat + ', Max-' + row.maxLevelFloat : row.replenishmentMethodType) + ')';
					row.oneYearReq = numberFormatService.getWithParameters(row.oneYearReq, numberOfDecimals(row.oneYearReq));
					row.onOrderIslt = integerFormatService.getWithParameters(row.onOrderIslt, 0);
					row.analysisAvgDailyDemand += ' (' + numberFormatService.getWithParameters(row.analysisAvgDailyDemandFloat * 22, 2) + ' ' + row.uom + ' / Month)';
					row.hasAccess = (globalConfig.user.authFacts[row.leanDirFactoryNdx] !== undefined);
					if (!row.buyerCode || row.buyerCode.toLowerCase() === 'undefinedbuyer' || row.buyerCode.toLowerCase() === 'unassignedbuyer') {
						row.buyerCode = '';
					}

					// excess to sell info and contact link
					if (row.hasOwnProperty('potentialToSellCapped')) {
						row.potentialToSellCappedDisplay = integerFormatService.getWithParameters(
							row.potentialToSellCapped, row.potentialToSellCapped < 1 ? 2 : 0);
						row.potentialToSellCappedSavingsDisplay = currencyFormatService.getWithParameters(
							row.potentialToSellCapped * localCostPerItem,
							numberOfDecimals(localCostPerItem), currencySymbol);
					}
					if (row.excessToSellUserFirstName != null) {
						row.excessToSellUserType = 'Excess to Sell Responsible';
						row.excessToSellContactFirstName = row.excessToSellUserFirstName;
						row.excessToSellContactLastName = row.excessToSellUserLastName;
						row.excessToSellContactEmail = row.excessToSellUserEmailAddress;
					} else {
						row.excessToSellUserType = 'Buyer';
						row.excessToSellContactFirstName = row.buyerFirstName;
						row.excessToSellContactLastName = row.buyerLastName;
						row.excessToSellContactEmail = row.buyerEmailAddress;
					}
					var factoryAlias = globalConfig.factory.name;
					if ($scope.selectedFactory) {
						factoryAlias = $scope.selectedFactory.factoryAlias;
					}
					row.excessToSellEmailSubject = 'Opportunity to buy ' +
						($scope.incomingLocation && $scope.incomingLocation === 'MaterialShortages' ? row.analysisExcessOnHandOverLTQty : row.potentialToSellCappedDisplay) + ' ' + row.uom + ' of ' + row.factoryName +
						' ' + row.itemCode + ' from ' + factoryAlias;
					row.excessToSellEmailBody = 'Hi ' + row.excessToSellContactFirstName + ',\n\n' +

						'There may be an opportunity for ' + ($scope.incomingLocation && $scope.incomingLocation === 'MaterialShortages' ? factoryAlias : row.factoryName) + ' to buy ' +
						($scope.incomingLocation && $scope.incomingLocation === 'MaterialShortages' ? row.analysisExcessOnHandOverLTQty : row.potentialToSellCappedDisplay) + ' ' + row.uom + ' from ' +
						($scope.incomingLocation && $scope.incomingLocation === 'MaterialShortages' ? row.factoryName : factoryAlias) + '.\n\n' +

						'Here\'s some information about ' + row.factoryName + ' ' +
						row.itemCode + ' (as of ' + moment().format('ll') + '):\n' +
						'\n * 1 year requirements: ' + row.oneYearReq +
						'\n * Average Daily Demand: ' + row.analysisAvgDailyDemand +
						'\n * On Hand Qty: ' + row.totalOnHandQuantityFloat +
						'\n * On Order Qty: ' + row.totalOnOrderQuantityFloat +
						'\n * On Order Inside Lead Time: ' + row.onOrderIslt;
					if (row.itemCode !== $scope.itemMasterData.itemCodeDisplay) {
						row.excessToSellEmailBody += '\n * Equivalent Item Codes: ' +
							factoryAlias + ' ' + $scope.itemMasterData.itemCodeDisplay;
					}
					row.excessToSellEmailBody += '\n\n' +
						'View this item on LeanDNA using the link below:\n' +
						'https://' + window.location.host + '/application/f/home.html#/item-drilldown?itemCode=' +
						row.itemCode + '&factoryNdx=' + row.factoryNdx + '&byEmail=1&emailType=ets\n\n' +

						'Purchasing this item from ' + ($scope.incomingLocation && $scope.incomingLocation === 'MaterialShortages' ? row.factoryName : factoryAlias) +
						' would help decrease ' + ($scope.incomingLocation && $scope.incomingLocation === 'MaterialShortages' ? '' : 'our') + ' purchased inventory and could help ' +
						globalConfig.customer.name + ' save money.\n\n' +

						'Is this something you can help me with?\n\n' +

						'Thank you,\n' +
						globalConfig.user.firstName + ' ' + globalConfig.user.lastName;
					row.excessToSellEmailSubject = encodeURIComponent(row.excessToSellEmailSubject);
					row.excessToSellEmailBody = encodeURIComponent(row.excessToSellEmailBody);
					if ($scope.incomingLocation && $scope.incomingLocation === 'MaterialShortages' && row.excessOverLtMultiple > 0) {
						row.potentialToSellForShortages = true;
					}


					if (row.analysisExcessOnHandQuantityByDaysFloat) {
						row.analysisExcessOnHandQuantityByDaysFloat = integerFormatService.getWithParameters(row.analysisExcessOnHandQuantityByDaysFloat, 0);
					}
				});
			}

			function formatAlternateItemsList() {
				angular.forEach($scope.alternateItems, function (row) {
					row.itemCode = row.itemCodeDisplay;
					row.costPerItemFloat = currencyFormatService.getWithParameters(row.costPerItemFloat, 0, currencySymbol);
					row.analysisTotalDemand = numberFormatService.getWithParameters(row.analysisTotalDemand, 0);
					row.totalOnHandQuantityFloat = integerFormatService.getWithParameters(row.totalOnHandQuantityFloat, 0);
					if (row.daysDisplayType !== 'Calendar Days') {
						row.leadTimeInDaysFloatDisplay = integerFormatService.getWithParameters(row.leadTimeInDaysFloat / 7 * 5, 0) + ' Work Days';
					} else {
						row.leadTimeInDaysFloatDisplay = integerFormatService.getWithParameters(row.leadTimeInDaysFloat, 0);
					}
					row.oneYearReq = numberFormatService.getWithParameters(row.oneYearReq, numberOfDecimals(row.oneYearReq)) + ' ' + row.uom;
					if (row.analysisExcessOnHandOverLTQty) {
						row.analysisExcessOnHandOverLTQty = numberFormatService.getWithParameters(row.analysisExcessOnHandOverLTQty, numberOfDecimals(row.analysisExcessOnHandOverLTQty)) + ' ' + row.uom;
					} else {
						row.analysisExcessOnHandOverLTQty = '0 ' + row.uom;
					}
				});
			}

			function addDecimalIfNeeded(value, keepNegativeSign) {
				var numDecimals = 0;
				var isNegative = value < 0;
				if (isNegative) {
					value *= -1;
				}
				if (value % 1 !== 0 && value < 100) {
					numDecimals = decimalPlaces(value);
				}
				if (isNegative) {
					value *= -1;
				}
				return integerFormatService.getWithParameters(value, numDecimals, keepNegativeSign);
			}

			function getMultitenant() {
				$scope.loadingMultitenantSection = true;
				if ($scope.itemCode) {
					itemDetailsService.getMultitenant($scope.itemCode, $scope.siteId)
						.then(function (data) {
							$scope.loadMultitenant = true;
							$scope.hasMultitenantData = data && data.data && data.data.length > 0;
							$scope.loadingMultitenantSection = false;
							if ($scope.hasMultitenantData) {
								formatMultitenantList(data.data, data.currencyBySite, data.localCostPerItem);
								$scope.multitenant = data.data;
								if ($scope.sortMultitenantByExcessToSell) {
									$scope.multitenant.sort(function sortMultitenantByExcessToSell (a, b) {
										return b.potentialToSell - a.potentialToSell;
									});
								} else if ($scope.incomingLocation === 'MaterialShortages') {
									$scope.multitenant.sort(function sortMultiTenent (a, b) {
                                    	return b.excessOverLtMultiple - a.excessOverLtMultiple;
									});
								}
							}
						});
				}
			}

			function formatMultiprojectList(rows) {
				if (!rows) { return; }
				angular.forEach(rows, function (row) {
					if (row.onHand != null) {
						row.onHand = numberFormatService.getWithParameters(row.onHand, numberOfDecimals(row.onHand));
					}
					if (row.onHandUnrestrictedConsignment != null) {
						row.onHandUnrestrictedConsignment = numberFormatService.getWithParameters(row.onHandUnrestrictedConsignment, numberOfDecimals(row.onHandUnrestrictedConsignment));
					}
					if (row.leadTime != null) {
						row.leadTime = numberFormatService.getWithParameters(row.leadTime, numberOfDecimals(row.leadTime));
					}
					if (row.excessOverLeadTime != null) {
						row.excessOverLeadTime = numberFormatService.getWithParameters(row.excessOverLeadTime, numberOfDecimals(row.excessOverLeadTime));
					}
					if (row.excessAvailableToSell != null) {
						row.excessAvailableToSell = numberFormatService.getWithParameters(row.excessAvailableToSell, numberOfDecimals(row.excessAvailableToSell));
					}
				});
			}

			function getMultiproject() {
				$scope.loadingMultiprojectSection = true;
				if ($scope.itemCode) {
					itemDetailsService.getMultiproject($scope.itemCode, $scope.siteId)
						.then(function (data) {
							$scope.loadMultiproject = true;
							$scope.hasMultiprojectExcessData = data && data.data && data.data.length > 0;
							$scope.multiproject = data && data.data ? data.data : [];
							formatMultiprojectList($scope.multiproject);
							$scope.loadingMultiprojectSection = false;
						})
						.catch(function () {
							$scope.hasMultiprojectExcessData = false;
							$scope.multiproject = [];
							$scope.loadingMultiprojectSection = false;
						});
				} else {
					$scope.loadingMultiprojectSection = false;
				}
			}

			function getHistorical() {
				$scope.loadingHistoricalSection = true;
				if ($scope.itemCode) {
					itemDetailsService.getHistorical($scope.itemCode, $scope.siteId)
						.then(function (data) {
							$scope.historical = data;
							$scope.hasHistoricalData = $scope.historical && $scope.historical.length > 0;
							$scope.loadHistorical = true;
							formatHistoricalList();
							$scope.loadingHistoricalSection = false;
						});
				}
			}

			function getAlternateItems() {
				$scope.loadingAlternateItemSection = true;
				if ($scope.itemCode) {
					itemDetailsService.getAlternateItems($scope.itemCode, $scope.siteId)
						.then(function (data) {
							$scope.alternateItems = data;
							$scope.hasAlternateItemData = $scope.alternateItems && $scope.alternateItems.length > 0;
							$scope.loadAlternateItems = true;
							formatAlternateItemsList();
							$scope.loadingAlternateItemSection = false;
						});
				}
			}

			$scope.getRequirementPeriod = function(BucketsInPeriodInt) {
				return BucketsInPeriodInt + ' weeks';
			};

			$scope.toggleActivity = function () {
				$scope.showMoreActivity = !$scope.showMoreActivity;
				if ($scope.showMoreActivity) {
					$scope.toggleActivityText = 'Show Less Activity';
				} else {
					$scope.toggleActivityText = 'Show More Activity';
				}
			};

			function getManufacturedHistorical() {
				$scope.loadingManufacturedHistoricalSection = true;
				if ($scope.itemCode) {
					itemDetailsService.getManufacturedHistorical($scope.itemCode, $scope.siteId)
						.then(function (data) {
							$scope.historicalManufacturedData = data;
							$scope.hasManufacturedHistoricalData = $scope.historicalManufacturedData &&
								$scope.historicalManufacturedData.length > 0;
							$scope.loadManufacturedHistorical = true;
							formatManufacturedHistoricalList();
							$scope.loadingManufacturedHistoricalSection = false;
						});
				}
			}

			function getActualPo() {
				$scope.loadingDeliveriesSection = true;
				if ($scope.itemCode) {
					itemDetailsService.getActualPo($scope.itemCode, $scope.siteId)
						.then(function (data) {
							$scope.actualPo = data;
							$scope.hasDeliveryData = $scope.actualPo && $scope.actualPo.length > 0;
							$scope.loadActualPo = true;
							formatDeliveriesList();
							$scope.loadingDeliveriesSection = false;
						});
				}
			}

			function getActionHistory() {
				$scope.loadingActionHistorySection = true;
				if ($scope.itemCode && $rootScope.authz.isLeanDNAAdmin()) {
					inventoryActionsService.getHistory($scope.siteId, $scope.itemMasterData.itemNdx)
						.then(function (data) {
							$scope.hasActionHistory = data && data.length > 0;
							formatActionHistoryList(data);
							$scope.loadingActionHistorySection = false;
						});
				}
			}

			function getPoRecommendations() {
				$scope.poRecTabReady = false;
				if ($scope.itemCode && $rootScope.authz.isLeanDNAAdmin()) {
					itemDetailsService.getPoRecommendations($scope.itemCode, $scope.siteId)
						.then(function (data) {
							$scope.hasPORecommendations = data && data.length > 0;

							if ($scope.hasPORecommendations) {
								var i;
								for (i = 0; i < data.length; i++) {
									var rec = data[i];

									if (rec.originalDate) {
										rec.originalDateDisplay = moment(rec.originalDate).format('L');
									}
									if (rec.goldenSupplyDate) {
										rec.requestedDateDisplay = moment(rec.goldenSupplyDate).format('L');
									}
									if (rec.analysisRescheduleDate) {
										rec.analysisRescheduleDateDisplay = moment(rec.analysisRescheduleDate).format('L');
									}
								}
							}
							$scope.poRecTabReady = true;
							storeService.dispatch(storeService.actionCreators.itemDrilldown.setPoRecommendations(data));
							$scope.$broadcast('poRecChartReadyToLoad');
						});
				}
			}

			function getIAStatusedPoRecs() {
				$scope.poRecTabReady = false;
				if ($scope.itemCode && $rootScope.authz.isLeanDNAAdmin()) {
					itemDetailsService.getIAStatusedPoRecs($scope.itemCode, $scope.siteId)
						.then(function (data) {
							if (data !== '') {
								storeService.dispatch(storeService.actionCreators.itemDrilldown.setIaStatusedPoRecs(data));
							}
						});
				}
			}

			function addDetailsToHistoryEntry(actionType, historyEntry, detailsJSON) {
				var details = JSON.parse(detailsJSON);

				if (details != null) {
					historyEntry.costPerItemFloat = details.costPerItemFloat;
					historyEntry.onHandValue = details.onHandValue;
					historyEntry.projectedValue = details.projectedValue;
					historyEntry.targetValue = details.targetValue;

					if (actionType === 'VMILevel') {
						historyEntry.curentMin = details.currentMin;
						historyEntry.currentMax = details.currentMax;
						historyEntry.recommendedMin = details.recommendedMin;
						historyEntry.recommendedMax = details.recommendedMax;
						historyEntry.vmi6MonthTargetSavings = details.vmi6MonthTargetSavings;
						historyEntry.minMaxResizeSavings = details.minMaxResizeSavings;
					} else if (actionType === 'MRPResize') {
						historyEntry.currentOrderPolicy = details.currentOrderPolicy;
						historyEntry.currentLotSize = details.currentLotSize;
						historyEntry.proposedLotSize = details.proposedLotSize;
						historyEntry.currentOrderInterval = details.currentOrderInterval;
						historyEntry.proposedOrderInterval = details.proposedOrderInterval;
						historyEntry.currentLotByLotSize = details.currentLotByLotSize;
						historyEntry.orderPolicyActionSavings = details.orderPolicyActionSavings;
					} else if (actionType === 'POForExcess') {
						historyEntry.remainingQuantity = details.sixMonthQuantities.remainingQuantity;
						historyEntry.requiredQuantity = details.sixMonthQuantities.requiredQuantity;
						historyEntry.receivedQuantity = details.sixMonthQuantities.receivedQuantity;
						historyEntry.month6PoActionCum = details.month6PoActionCum;
					} else if (actionType === 'ROPResize') {
						historyEntry.safetyStock = details.safetyStock;
						historyEntry.currentReorderPoint = details.currentReorderPoint;
						historyEntry.currentReorderQty = details.currentReorderQty;
						historyEntry.recommendedReorderPoint = details.recommendedReorderPoint;
						historyEntry.recommendedReorderQty = details.recommendedReorderQty;
						historyEntry.reorderPointActionSavings = details.reorderPointActionSavings;
					} else if (actionType === 'ExcessToSell') {
						historyEntry.excessAmount = details.excessAmount;
						historyEntry.transferQuantity = details.transferQuantity;
					}
				}
			}

			function formatActionHistoryList(data) {
				var actions = {};
				var actionIds = [];
				$scope.actionHistory = [];
				var i;

				for (i = 0; i < data.length; i++) {
					var rawHistoryEntry = data[i];

					// add initial entry
					if (!actions.hasOwnProperty(rawHistoryEntry.actionId)) {
						actionIds.push(rawHistoryEntry.actionId);
						var initialHistory = {
							date: moment(rawHistoryEntry.dateCreated).format('L'),
							state: 'open',
							potentialSavings: rawHistoryEntry.originalSavingsAmount,
							potentialCostAvoidance: rawHistoryEntry.originalCostAvoidance
						};

						addDetailsToHistoryEntry(rawHistoryEntry.actionType,
							initialHistory, rawHistoryEntry.details);

						actions[rawHistoryEntry.actionId] = {
							actionType: rawHistoryEntry.actionType,
							history: [initialHistory]
						};
					}

					// add non-initial entry
					if (rawHistoryEntry.state !== 'initial') {
						var newHistory = {
							date: moment(rawHistoryEntry.dateUpdated).format('L'),
							state: rawHistoryEntry.state,
							potentialSavings: rawHistoryEntry.potentialSavings,
							potentialCostAvoidance: rawHistoryEntry.potentialCostAvoidance,
							actualSavingsAmount: rawHistoryEntry.savings,
							actualCostAvoidance: rawHistoryEntry.costAvoidance,
							expired: rawHistoryEntry.expired,
							invalidAmount: rawHistoryEntry.invalidAmount
						};

						addDetailsToHistoryEntry(rawHistoryEntry.actionType,
							newHistory, rawHistoryEntry.updatedDetails);

						actions[rawHistoryEntry.actionId].history.push(newHistory);
					}
				}

				// convert to list
				for (i = 0; i < actionIds.length; i++) {
					$scope.actionHistory.push(actions[actionIds[i]]);
				}
			}

			function broadcastMrpDataReady(doBroadcast, useRootCauseDate) {
				if (!$scope.sidebarOnlyMode && doBroadcast && $scope.mrpTabReady) {
					timeouts['mrpChartReadyToLoad'] = $timeout(function () {
						$scope.$broadcast('mrpChartReadyToLoad', { useRootCauseDate: useRootCauseDate });
					});
				}
			}

			function formatDays(dayValue, allowDecimals) {
				var daysDisplayType = $scope.daysDisplayType;
				var daysConversion = daysDisplayType !== 'Calendar Days' ? 5 / 7 : 1;
				if (dayValue == null || dayValue === '') {
					dayValue = 0;
				} else {
					var value = dayValue * daysConversion;
					if (allowDecimals) {
						dayValue = storeService.formatterService.formatNumberDecimals(value);
					} else {
						dayValue = integerFormatService.getWithParameters(value, 0, 1);
					}
				}

				dayValue = dayValue < 0 ? 0 : dayValue;
				var dayString;
				if (daysDisplayType === 'Calendar Days') {
					dayString = dayValue + ' Day';
				} else {
					dayString = dayValue + ' Work Day';
				}
				dayString += dayValue > 1 || dayValue < 1 ? 's' : '';
				return dayString;
			}

			function loadItemMasterSiteSettingsAndItemDetails() {
				$scope.loadingMasterSection = true;
				$scope.showCompanyDemandDrilldown = true;
				$scope.isCompanyDemandPast = false;
				$scope.useGreaterOfPastOrFuture = false;
				$scope.factorySettingsList = [
					'PROCUREMENT_BUCKETS_IN_PERIOD',
					'PROCUREMENT_SAFETY_STOCK_TYPE_IN_TARGET_INVENTORY',
					'PROCUREMENT_USE_ORDER_INTERVAL_FOR_LOGICAL_LEADTIME',
					'PROCUREMENT_RECEIVING_TIME_DAYS',
					'PROCUREMENT_LEAD_TIME_DAYS',
					'PROCUREMENT_REQUIREMENT_SOURCE_FOR_CALCULATIONS',
					'PROCUREMENT_USE_HISTORICAL_USAGE_WHEN_GREATER'
				];
				factorySettingService.getFactorySettings($scope.factorySettingsList, $scope.siteId)
					.then(function (settings) {
						$scope.requirementPeriod = settings.PROCUREMENT_BUCKETS_IN_PERIOD + ' weeks';
						$scope.useOrderIntervalForLogicalLeadtime = settings.PROCUREMENT_USE_ORDER_INTERVAL_FOR_LOGICAL_LEADTIME;
						if (settings.PROCUREMENT_SAFETY_STOCK_TYPE_IN_TARGET_INVENTORY === 'Analysis') {
							$scope.isErpSafetyStock = false;
						} else {
							$scope.isErpSafetyStock = true;
						}
						$scope.factoryReceivingTime = settings.PROCUREMENT_RECEIVING_TIME_DAYS;
						$scope.factoryProcurementLeadtime = settings.PROCUREMENT_LEAD_TIME_DAYS;

						switch (settings.PROCUREMENT_REQUIREMENT_SOURCE_FOR_CALCULATIONS) {
						case 'Past':
							$scope.isCompanyDemandPast = true;
							break;
						case 'Future':
							if (settings.PROCUREMENT_USE_HISTORICAL_USAGE_WHEN_GREATER) {
								$scope.useGreaterOfPastOrFuture = true;
							}
							break;
						case 'PastAndFuture':
							$scope.showCompanyDemandDrilldown = false;
							break;
						}

						loadItemMasterData();
					});
			}

			function loadItemMasterData() {
				if ((itemCode || procureRptNdx) && !$scope.supplierPortal) {
					if (!$scope.siteId) {
						$scope.enableDrilldowns = true;
						$scope.siteId = globalConfig.factory.id;
						currencySymbol = globalConfig.user.authFacts[$scope.siteId].currencySymbol;
						$scope.drilldownFactoryNdx = $scope.siteId;
					}
					if (!isIopCampaignsEnabled()) {
						storeService.dispatch(storeService.actionCreators.itemDrilldown.resetItemCampaign());
					} else if (itemCode && $scope.drilldownFactoryNdx) {
						storeService.dispatch(storeService.thunks.fetchItemCampaignSummary({
							factoryNdx: String($scope.drilldownFactoryNdx),
							fullItemCode: itemCode
						}));
					}
					setDescriptiveHelpState();
					$scope.itemCode = itemCode;
					$scope.showAlternateLeadTimeMultipleText = true;
					itemDetailsService.getItemMasterData(itemCode, procureRptNdx, undefined, $scope.itemType, $scope.siteId)
						.then(function (data) {
							if (data) {
								if (data.itemCode !== $scope.itemCode || '' + data.factoryNdx !== '' + $scope.drilldownFactoryNdx) {
									return;
								}

								$scope.itemMasterData = data;

								if ($scope.itemType == undefined) {
									$scope.itemType = $scope.itemMasterData.itemType;
								}

								$scope.isManufacturedItem = $scope.itemType === 'Manufactured';

								$scope.requirementSourceForCalculation = globalConfig.user.authFacts[$scope.siteId].settings['RequirementSourceForCalculations'];
								$scope.bucketsInPeriodInt = globalConfig.user.authFacts[$scope.siteId].settings['BucketsInPeriodInt'];
								$scope.useHistoricalUsageWhenGreater = globalConfig.user.authFacts[$scope.siteId].settings['UseHistoricalUsageWhenGreater'];
								$scope.weeksInPastDemandCalculations = globalConfig.user.authFacts[$scope.siteId].settings['WeeksInPastDemandCalculations'];
								$scope.showForwardDemandDOI = globalConfig.user.authFacts[$scope.siteId].settings['UseForwardOnlyDemandForForwardDOI'] === 1 || globalConfig.user.authFacts[$scope.siteId].settings['UseForwardOnlyDemandForForwardDOI'] === '1';
								$scope.forwardDOIWindow = globalConfig.user.authFacts[$scope.siteId].settings['ForwardDOIWindow'];
								$scope.forwardDOIHelpText = $translate.instant('Forward DOI uses forward-only demand within the site\'s configured window ({{weeks}} weeks). Values may differ across sites depending on whether this setting is enabled.', { weeks: $scope.forwardDOIWindow });
								$scope.daysDisplayType = globalConfig.user.authFacts[$scope.itemMasterData.factoryNdx].daysDisplayType;
								$scope.receivingTimeIsDefault = false;
								if ($scope.itemMasterData.receivingTime > -1) {
									$scope.itemMasterData.receivingTimeDisplay = formatDays($scope.itemMasterData.receivingTime);
								} else {
									$scope.receivingTimeIsDefault = true;
									$scope.itemMasterData.receivingTimeDisplay = formatDays($scope.factoryReceivingTime);
								}
								$scope.procurementLeadtimeIsDefault = false;
								if ($scope.itemMasterData.procurementLeadtime > -1) {
									$scope.itemMasterData.procurementLeadtimeDisplay = formatDays($scope.itemMasterData.procurementLeadtime);
								} else {
									$scope.procurementLeadtimeIsDefault = true;
									$scope.itemMasterData.procurementLeadtimeDisplay = formatDays($scope.factoryProcurementLeadtime);
								}
								$scope.detailType = $scope.itemMasterData.detailType;
								$scope.itemCode = $scope.itemMasterData.code;
								$scope.itemDescription = $scope.itemMasterData.itemDescription;
								$scope.trimmedCode = $scope.itemMasterData.itemCodeDisplay;
								$scope.itemMasterData.leadTimeInDaysFloat = $scope.itemMasterData.leadTimeInDaysFloat || 0;
								$scope.itemMasterData.leadTimeInDaysFloatDisplay = formatDays($scope.itemMasterData.leadTimeInDaysFloat, true);
								$scope.itemMasterData.orderPolicyValueDisplay = formatDays($scope.itemMasterData.orderPolicyValue);
								$scope.itemMasterData.safetyLeadtimeDisplay = formatDays($scope.itemMasterData.safetyLeadtime);
								$scope.itemMasterData.analysisMultipleLeadTimeFloat = numberFormatService.getWithParameters(
									$scope.itemMasterData.analysisMultipleLeadTimeFloat, numberOfDecimals($scope.itemMasterData.analysisMultipleLeadTimeFloat));
								$scope.itemMasterData.reorderPointDisplay = integerFormatService.getWithParameters($scope.itemMasterData.reorderPointFloat, 0);
								$scope.itemMasterData.recommendedReorderPointDisplay = integerFormatService.getWithParameters($scope.itemMasterData.recommendedReorderPointInt, 0);
								$scope.itemMasterData.reorderQtyDisplay = integerFormatService.getWithParameters($scope.itemMasterData.currentReorderQty, 0, true);
								$scope.itemMasterData.recommendedReorderQtyFloatDisplay = integerFormatService.getWithParameters($scope.itemMasterData.recommendedReorderQtyFloat, 0);
								$scope.itemMasterData.averageMonthlyUsage = integerFormatService.getWithParameters($scope.itemMasterData.averageMonthlyUsage, numberOfDecimals($scope.itemMasterData.averageMonthlyUsage), true);
								$scope.showAlternateLeadTimeMultipleText = $scope.showAlternateLeadTimeMultipleText && $scope.itemMasterData.orderPolicy == 'Order Interval';
								incomingData.itemCode = $scope.itemCode;
								incomingData.itemCodeDisplay = $scope.trimmedCode;
								incomingData.itemNdx = $scope.itemMasterData.itemNdx;
								$scope.status = {
									isOpen: true
								};
								if (!$scope.itemMasterData.abcClass || $scope.itemMasterData.abcClass === '-') {
									$scope.itemMasterData.abcClass = 'Not defined';
								}
								if ($scope.itemType !== undefined && $scope.itemType === 'Manufactured') {
									$scope.analysisSection = false;
									getManufacturedHistorical();
									getMultitenant();
								} else {
									getMultitenant();
									getActualPo();
									getHistorical();
									getAlternateItems();
									getActionHistory();
									getPoRecommendations();
									getIAStatusedPoRecs();
								}
								if ($scope.showCrossProjectExcessTab) {
									getMultiproject();
								}

								populateAndFormatViewVariables();
								$scope.emptyItem = false;
								$scope.mrpTabReady = true;
								$scope.poRecTabReady = true;
							} else {
								$scope.loadingOrderData = false;
								$scope.loadingMasterSection = false;
								$scope.loadingDeliveriesSection = false;
								$scope.loadingHistoricalSection = false;
								$scope.loadingMultitenantSection = false;
								$scope.loadingMultiprojectSection = false;
								$scope.loadingItemActivityFeed = false;
								$scope.loadingAlternateItemSection = false;
								$scope.loadingActionHistorySection = false;
								$scope.emptyItem = true;
								$scope.itemFlexFields = [];
								$scope.itemFlexFieldRows = [];
								$scope.mrpTabReady = false;
								$scope.poRecTabReady = false;
							}

							broadcastMrpDataReady(true, useRootCauseDateInHistory);
							refreshCampaignActionsTabVisibility();
							if ($scope.showCampaignActionsTab && $scope.pendingCampaignDefaultTab) {
								$scope.activeTab = 'campaign-actions';
								$scope.tab.activeTabIndex = 0;
								$scope.pendingCampaignDefaultTab = false;
							}
							$scope.selectTab($scope.activeTab, true, useRootCauseDateInHistory);
							$scope.loadingMasterSection = false;
						});
					$scope.showAlternateLeadTimeMultipleText = $scope.showAlternateLeadTimeMultipleText && $scope.useOrderIntervalForLogicalLeadtime;
				}
			}

			function callGetAction() {
				$scope.loadAction = true;
				var element = angular.element(document.getElementById('tasksView'));
				if (!element || !element.scope()) {
					$timeout(function () {
						callGetAction();
					}, 10);
					return;
				}
				$scope.actionsScope = element.scope();
				if ($scope.actionsScope) {
					$scope.actionsScope.getAction(undefined, $scope.incomingLocation, $scope.itemCode, $scope.row, $scope.rowIndex, $scope.siteId, undefined, $scope.insidePanel, $scope.specificTaskType, $scope.specificTaskId);
				}
			}

			function updateDefaultTab(tab, type, shortageRootCauseType) {
				if (tab && tab !== '') {
					// todo: remove this check when the experiment is permanently disable and we move to new buyer workflow.
					// Change the table-render servive and update the default section from stockSection to supplyAndDemandSection
					var selectedTab = $scope.tabMap[tab.trim()];
					if (selectedTab === 'stock') {
						selectedTab = 'supplyAndDemand';
					}
					$scope.selectTab(selectedTab, false, shortageRootCauseType && shortageRootCauseType.length);
				} else {
					$scope.pendingCampaignDefaultTab = true;
					$scope.selectTab('supplyAndDemand', false);
				}
			}

			function addTaskAction() {
				if (!$scope.itemMasterData) {
					// Wait until data is loaded
					return;
				}
				var obj = {};
				obj.inventoryActionType = inventoryActionType;
				obj.factoryNdx = $scope.siteId;
				obj.itemNdx = $scope.itemMasterData.itemNdx;
				obj.itemCodeDisplay = $scope.itemMasterData.itemCodeDisplay;
				obj.fullItemCode = $scope.itemMasterData.fullItemCode || $scope.itemCode;
				obj.row = $scope.row;
				obj.rowIndex = $scope.rowIndex;
				obj.incomingLocation = $scope.incomingLocation;
				obj.specificTaskType = $scope.specificTaskType;
				$rootScope.$broadcast('addNewProcurementTask', obj);
			}

			$scope.openItemDrillDown = function (data) {
				// make sure mrpTabReady is reset at start
				$scope.mrpTabReady = false;
				$scope.openModal(data['fullItemCode'], undefined, 'Other Site Tab',
					globalConfig.user.role === 'Supplier', data['itemCodeDisplay'],
					data['description'], undefined, undefined, undefined,
					data['itemType'], data['leanDirFactoryNdx'], undefined, undefined, undefined, undefined, undefined);
			};

			var openItemDrilldownCallback = function (drilldownArgs) {
				storeService.dispatch(storeService.actionCreators.setDrawerOpen(false));
				$scope.addColumnSidebarOpen = false;
				$scope.showSupplyAndDemandDownload = false;
				$scope.showCampaignPoActionsDownload = false;
				storeService.dispatch(storeService.actionCreators.itemDrilldown.setDownloadSupplyAndDemadReport(false));
				storeService.dispatch(storeService.actionCreators.itemDrilldown.setDownloadCampaignPoActionsReport(false));
				storeService.dispatch(storeService.actionCreators.itemDrilldown.resetItemCampaign());
				$scope.pendingCampaignDefaultTab = !drilldownArgs.defaultTab;
				openItemDrilldown(
					drilldownArgs.itemCode,
					drilldownArgs.fullItemCode,
					drilldownArgs.itemType,
					drilldownArgs.itemDescription,
					drilldownArgs.row,
					drilldownArgs.rowIndex,
					drilldownArgs.taskId,
					drilldownArgs.actionId,
					drilldownArgs.factoryNdx,
					drilldownArgs.exactMatch != null && drilldownArgs.exactMatch,
					drilldownArgs.defaultTab,
					drilldownArgs.supplyAndDemandFilterActive,
					drilldownArgs.itemNdx,
					drilldownArgs.expandDoneSection,
					drilldownArgs.openSidebar,
					drilldownArgs.sidebarOnlyMode,
					drilldownArgs.currentTableName,
					drilldownArgs.openChat,
					drilldownArgs.chatId,
					drilldownArgs.chatType,
					null,
					drilldownArgs.chatTab
				);
				storeService.dispatch(storeService.actionCreators.setCurrentTableAndChatOpenedFrom(drilldownArgs.currentTableName));
			};

			var reloadNewItemDrilldown = function (drilldownArgs) {
				storeService.dispatch(storeService.actionCreators.itemDrilldown.resetItemCampaign());
				$scope.pendingCampaignDefaultTab = !drilldownArgs.defaultTab;
				openItemDrilldown(
					drilldownArgs.itemCode,
					drilldownArgs.fullItemCode,
					drilldownArgs.itemType,
					drilldownArgs.itemDescription,
					drilldownArgs.row,
					drilldownArgs.rowIndex,
					drilldownArgs.taskId,
					drilldownArgs.actionId,
					drilldownArgs.factoryNdx,
					drilldownArgs.exactMatch != null && drilldownArgs.exactMatch,
					drilldownArgs.defaultTab,
					drilldownArgs.supplyAndDemandFilterActive,
					drilldownArgs.itemNdx,
					drilldownArgs.expandDoneSection,
					drilldownArgs.openSidebar,
					drilldownArgs.sidebarOnlyMode,
					drilldownArgs.currentTableName,
					drilldownArgs.openChat,
					drilldownArgs.chatId,
					drilldownArgs.chatType,
					drilldownArgs.fromInlineSearch,
					drilldownArgs.chatTab
				);
			};

			$scope.$on('itemDrilldownClosed', function (event, params) {
				storeService.dispatch(storeService.actionCreators.setDrawerOpen(false));
				if (params && !params['isInitialClose']) {
					storeService.dispatch(storeService.actionCreators.setCurrentTableAndChatOpenedFrom(''));
					storeService.dispatch(storeService.actionCreators.modal.closeModal());
				}
			});

			function dataTrackingInfo(factoryNdx) {
				$scope.dataTrackingElem.setAttribute('data-tracking-itemDrilldown-factoryNdx', factoryNdx.toString());
			}

			function openItemDrilldown(itemCode, fullItemCode, itemType, itemDescription, row, rowIndex, taskId, actionId, 
					factoryNdx, exactMatch, defaultTab, supplyAndDemandFilterActive, itemNdx, expandDoneSection, openSidebar, 
					sidebarOnlyMode, currentTableName, openChat, chatId, chatType, fromInlineSearch, chatTab) {
				refreshCampaignActionsTabVisibility();
				if (defaultTab) {
					$scope.pendingCampaignDefaultTab = false;
				}
				if (itemCode) {
					factoryNdx = factoryNdx || 'LDNA_A_S';
					var specificTaskType;
					if (actionId) {
						specificTaskType = 'action';
						taskId = actionId;
					} else if (taskId) {
						specificTaskType = 'task';
					}
					//if at least one of these is not provided, then search for the item.
					if (!fullItemCode || !itemType || !itemDescription) {
						// open item drilldown on top of the report
						// use item search api call to get the necessary extra details
						var url = '/api/2/factndx/' + factoryNdx + '/ItemSearch';
						var body = {
							operation: 'rows',
							columns: [],
							filters: [],
							paging: {
								start: 0,
								limit: 10
							},
							extraParams: {
								search: itemCode,
								exactMatch: exactMatch
							}
						};
						if (itemNdx) {
							body.extraParams.itemNdx = itemNdx;
						}
						$http.post(url, body).then(function(response) {
							var itemData = response.data && response.data.data && response.data.data[0];
							$scope.openModal(
								itemData.fullItemCode,
								row,
								'Email Link',
								globalConfig.user.role === 'Supplier',
								itemData.itemCode,
								itemData.description,
								rowIndex,
								defaultTab,
								undefined,
								itemData.itemType,
								factoryNdx,
								specificTaskType,
								taskId,
								undefined,
								taskId,
								supplyAndDemandFilterActive,
								expandDoneSection,
								openSidebar,
								sidebarOnlyMode,
								currentTableName,
								openChat,
								chatId,
								chatType,
								fromInlineSearch,
								chatTab
							);
						});
					} else {
						$scope.openModal(
							fullItemCode,
							row,
							'Email Link',
							globalConfig.user.role === 'Supplier',
							itemCode,
							itemDescription,
							rowIndex,
							defaultTab,
							undefined,
							itemType,
							factoryNdx,
							specificTaskType,
							taskId,
							undefined,
							taskId,
							supplyAndDemandFilterActive,
							expandDoneSection,
							openSidebar,
							sidebarOnlyMode,
							currentTableName,
							openChat,
							chatId,
							chatType,
							fromInlineSearch,
							chatTab
						);
					}
				}
			}

			function getInventoryDrilldownUrl(args) {
				if (!$scope.itemMasterData) {
					return '';
				}
				return drilldownFunctionsService.getReportDrilldownUrl(
					$scope.isManufacturedItem ? 'supply-chain/inventory/manufactured-inventory' : 'supply-chain/inventory/purchased-inventory/',
					null,
					{
						state: args ? args.state : undefined,
						search: $scope.itemMasterData.code,
						factory: $scope.drilldownFactoryNdx
					},
					true
				);
			}

			function getSupplyOrdersDrilldownUrl(factoryNdx, itemCode) {
				var supplyOrdersUrl = '/application/f/home.html#/supply-chain/supply-orders';
				var drilldownFilters = [
					drilldownFunctionsService.makeSelectFilter('factory', [factoryNdx]),
					drilldownFunctionsService.getMinimalFilterFromReportSettings({id: 'documentType', unselectedValues: ['Purchase Requisition']}),
					drilldownFunctionsService.makeRangeFilter('remainingQuantityFloat', leanFilterService.comparatorsMap.greaterThan, 0)
				];
				return supplyOrdersUrl + drilldownFunctionsService.makeDrilldownParamString(drilldownFilters, false, null, itemCode) + '&isOnOrderDrilldown=true';
			};

			function getPurchaseOrderReceiptsDrilldownUrl(fullItemCode, factoryNdx) {
				return drilldownFunctionsService.getReportDrilldownUrl('supply-chain/purchase-order-receipts', null,
					{
						search: fullItemCode,
						factory: factoryNdx
					},
					true
				);
			}

			function getPastRequirementsReportDrilldownUrl() {
				if (!$scope.itemMasterData) {
					return '';
				}

				return drilldownFunctionsService.getReportDrilldownUrl('supply-chain/past-requirements/',
					null,
					{
						search: $scope.itemMasterData.code,
						factory: $scope.drilldownFactoryNdx,
						searchOperator: 'exact'
					},
					true
				);
			}

			function getWeeklyRequirementReportDrilldownUrl() {
				if (!$scope.itemMasterData) {
					return '';
				}

				var pastUrl = getPastRequirementsReportDrilldownUrl();

				var futureUrl = drilldownFunctionsService.getReportDrilldownUrl(
					'supply-chain/requirements/weekly-requirements/',
					null,
					{
						search: $scope.itemMasterData.code,
						searchOperator: 'exact',
						factory: $scope.drilldownFactoryNdx
					}, true
				);

				if ($scope.isCompanyDemandPast) {
					return pastUrl;
				} else {
					var furtureDemand = $scope.itemMasterData.rawAverageDailyDemandFromFutureRqmts === 0 ? 0 : $scope.itemMasterData.rawAverageDailyDemandFromFutureRqmts;
					var pastDemand = $scope.itemMasterData.rawAverageDailyDemandFromPastRqmts === 0 ? 0 : $scope.itemMasterData.rawAverageDailyDemandFromPastRqmts;
					if ($scope.useGreaterOfPastOrFuture && pastDemand > furtureDemand) {
						return pastUrl;
					}
					return futureUrl;
				}
			}

			function init() {
				$scope.supplierPortal = globalConfig.user && globalConfig.user.role === 'Supplier';
				var loadingState = true;
				if (typeof $scope.itemType !== 'undefined' && $scope.itemType === 'Manufactured') {
					loadingState = false;
				}
				$scope.isLeanDNAAdmin = $rootScope.authz.isLeanDNAAdmin();
				$scope.showCrossProjectExcessTab = $experiments.isEnabled('cross-project-excess');
				$scope.hasAlternateItemData = false;
				$scope.hasMultitenantData = false;
				$scope.hasMultiprojectExcessData = false;
				$scope.loadingOrderData = loadingState;
				$scope.loadingMasterSection = loadingState;
				$scope.loadingDeliveriesSection = loadingState;
				$scope.loadingHistoricalSection = loadingState;
				$scope.loadingMultitenantSection = loadingState;
				$scope.loadingMultiprojectSection = loadingState;
				$scope.loadManufacturedHistorical = loadingState;
				$scope.loadingItemActivityFeed = true;
				$scope.loadingAlternateItemSection = loadingState;
				$scope.loadingActionHistorySection = loadingState;
				$scope.dataTrackingElem = document.getElementById('dataTrackingInfo');
				var defaultTab = search.defaultTab ? search.defaultTab : '';
				if (!$scope.isDrillDownModal) {
					updateDefaultTab(defaultTab, $scope.itemType, false);
				}

				if (!$scope.supplierPortal) {
					loadItemMasterSiteSettingsAndItemDetails();
				}

				dataTrackingInfo($scope.siteId);

				$scope.$on('showAddTask', function (event, showAddTask) {
					$scope.showAddTask = showAddTask;
				});

				$scope.addTaskAction = addTaskAction;
			}

			$scope.changeFactory = function (incFactoryNdx) {
				for (var i = 0; i < $scope.factoryList.length; i++) {
					if (incFactoryNdx === $scope.factoryList[i].leanDirFactoryNdx) {
						$scope.selectedFactory = $scope.factoryList[i];
						break;
					}
				}
				$scope.siteId = incFactoryNdx;
				currencySymbol = globalConfig.user.authFacts[$scope.siteId].currencySymbol;
				$scope.drilldownFactoryNdx = $scope.siteId;
				if ($scope.siteId !== globalConfig.factory.id.toString()) {
					$scope.enableDrilldowns = false;
				} else {
					$scope.enableDrilldowns = true;
				}
				init();
			};

			$scope.selectTab = function (tabName, doBroadcast, useRootCauseDate, isStateChanged) {
				if (tabName === 'campaign-actions') {
					if (!isIopCampaignsEnabled() || !itemHasCampaignFromState(storeService.getState())) {
						tabName = 'supplyAndDemand';
					}
				}
				$scope.activeTab = tabName;
				$scope.tab.activeTabIndex = $scope.tabIndexMap[$scope.activeTab];

				var isTabChangedFromStore = storeService.getState().previousAction.type === 'itemDrilldown/setCurrentlyOpenedTab' && storeService.getState().previousAction.payload === tabName;
				if (!isTabChangedFromStore && storeService.getState().itemDrilldown && tabName !== storeService.getState().itemDrilldown.currentlyOpenedTab) {
					storeService.dispatch(storeService.actionCreators.itemDrilldown.setCurrentlyOpenedTab(tabName || 'supplyAndDemand'));
				}

				switch ($scope.activeTab) {
				case 'historical-purchasing':
					getHistoricalSection();
					break;
				case 'deliveries':
					getDeliveriesSection();
					break;
				case 'stock':
					useRootCauseDateInHistory = useRootCauseDate;
					if (doBroadcast && $scope.mrpTabReady) {
						timeouts['mrpReadyToLoad'] = $timeout(function() {
							$scope.$broadcast('mrpReadyToLoad', {useRootCauseDate: useRootCauseDate});
						});
					}
					break;
				case 'alternative-item':
					getAlternateItemSection();
					break;
				case 'other-projects':
					break;
				}
			};

			function clearExistingTimeouts() {
				angular.forEach(timeouts, function(timeoutToClear) {
					if (timeoutToClear) {
						$timeout.cancel(timeoutToClear);
						timeoutToClear = null;
					}
				});
			}

			$scope.openModal = function (incomingCode, row, location, supplierPortal,
				itemCodeDisplay, itemDescription, rowIndex, defaultTab, widgetName,
				itemType, incomingFactoryNdxs, specificTaskType, taskId, shortageRootCauseType, currentTaskId,
				supplyAndDemandFilterActive, expandDoneSection, openSidebar, sidebarOnlyMode, currentTableName, openChat, chatId, chatType, fromInlineSearch, chatTab) {
				if(typeof openChat === 'undefined') {
					openChat = false;
					chatId = null;
					chatType = null;
				}
				clearExistingTimeouts();
				itemDetailsPendingRequestsService.cancelPendingRequest();
				if (!fromInlineSearch) {
					jQuery('.modal.item-modal').remove();
				}

				$scope.isDrillDownModal = true;
				$scope.incomingLocation = location;
				itemCode = incomingCode;
				$scope.loadingMasterSection = true;
				$scope.supplierPortal = supplierPortal;
				$scope.isManufacturedItem = false;
				$scope.itemCode = incomingCode;
				$scope.trimmedCode = itemCodeDisplay;
				$scope.itemDescription = itemDescription;
				$scope.rowIndex = rowIndex;
				$scope.specificTaskType = specificTaskType;
				$scope.specificTaskId = taskId;
				$scope.siteId = undefined;
				$scope.shortageRootCauseType = shortageRootCauseType;
				$scope.currentTaskId = currentTaskId;
				$scope.supplyAndDemandFilterActive = supplyAndDemandFilterActive;
				$scope.expandDoneSection = expandDoneSection;
				$scope.openSidebar = openSidebar;
				$scope.openChat = openChat;
				$scope.chatId = chatId;
				$scope.chatType = chatType;
				$scope.chatTab = chatTab;
				$scope.sidebarOnlyMode = sidebarOnlyMode || false;
				$scope.currentTableName = currentTableName;

				var incomingLocationsWithIasOrTasks = [
					'procurement-tasks',
					'inventory-actions',
					'open procurement tasks widget'
				];
				if (openSidebar === undefined && incomingLocationsWithIasOrTasks.indexOf(location) > -1) {
					$scope.openSidebar = true;
				}

				if (incomingFactoryNdxs && incomingFactoryNdxs.toString().length) {
					incomingFactoryNdxs = incomingFactoryNdxs.toString();
					var factoryNdxList = incomingFactoryNdxs.split(',');
					$scope.factoryList = getDisplayFactoryList(factoryNdxList);
					$scope.selectedFactory = $scope.factoryList[0];
					$scope.siteId = $scope.selectedFactory.leanDirFactoryNdx;
					currencySymbol = globalConfig.user.authFacts[$scope.siteId].currencySymbol;
					if ($scope.siteId !== globalConfig.factory.id.toString()) {
						$scope.enableDrilldowns = false;
					} else {
						$scope.enableDrilldowns = true;
					}
				}
				if (!$scope.siteId) {
					$scope.selectedFactory = undefined;
					$scope.factoryList = [];
					$scope.siteId = globalConfig.factory.id;
					currencySymbol = globalConfig.user.authFacts[$scope.siteId].currencySymbol;
					$scope.enableDrilldowns = true;
				}
				$scope.drilldownFactoryNdx = $scope.siteId;
				stockRequirementFiltersService.clearData($scope.itemCode, $scope.drilldownFactoryNdx);
				stockRequirementFiltersService.getSiteLevelDefaultConfig($scope.drilldownFactoryNdx);
				if (itemType !== undefined) {
					$scope.itemType = itemType;
					$scope.isManufacturedItem = (itemType === 'Manufactured');
				} else {
					$scope.itemType = undefined;
				}

				if ($scope.specificTaskType === 'action' && row && row.actionType === 'ExcessToSell') {
					$scope.sortMultitenantByExcessToSell = true;
					defaultTab = 'multitenantSection';
				} else {
					$scope.sortMultitenantByExcessToSell = false;
				}

				$scope.haveCurrentShortage = row ? row.haveCurrentShortage : false;
				if (widgetName) {
					pendo.track('widgetInteraction', {
						widgetType: widgetName,
						interaction: 'itemDrilldownOpened'
					});
				}
				updateDefaultTab(defaultTab, itemType, shortageRootCauseType);

				function openModal() {
					$scope.mrpTabReady = false;
					$scope.closeDialog(true);
					var canOpen = !jQuery('.checkForTaskSection').length && !jQuery('.modal').length;
					if (canOpen) {
						$scope.loadActualPo = false;
						$scope.loadHistorical = false;
						$scope.loadMultitenant = false;
						var instance = slideInModalService.openModal({
							scope: $scope,
							templateUrl: '/application/f/core/item-drilldown/item-drilldown.html',
							windowTemplateUrl: '/application/f/core/item-drilldown/item-drilldown-template.html',
							keyboard: false
						});
						opened = true;

						instance.result.then(function () {
							opened = false;
						});

						instance.result.catch(function() {
							jQuery('.inlineEditDiv').unbind();
							jQuery('.inlineEditDiv').remove();
							opened = false;
							$scope.closeDialog();
							clearExistingTimeouts();
						});
						startLoad();
					} else {
						timeouts['waitForPreviousModelClose'] = $timeout(function () {
							openModal();
						}, 10);
					}
				}

				function startLoad() {
					$scope.row = row;
					$scope.incomingLocation = location;
					$scope.loadAction = true;
					loadData();
				}

				function loadData() {
					var canLoad = jQuery('.checkForTaskSection').length;
					if (canLoad) {
						init();
					} else {
						timeouts['loadData'] = $timeout(function () {
							loadData();
						}, 10);
					}
				}

				$scope.handleDrawerClicked = function () {
					var newIsOpen = !$scope.addColumnSidebarOpen;
					storeService.dispatch(storeService.actionCreators.setDrawerOpen(newIsOpen));
					$scope.addColumnSidebarOpen = newIsOpen;
				};

				$scope.handleSupplyAndDemandExportClicked = function () {
					var show = !$scope.showSupplyAndDemandDownload;
					storeService.dispatch(storeService.actionCreators.itemDrilldown.setDownloadSupplyAndDemadReport(show));
					$scope.showSupplyAndDemandDownload = show;
				};

				$scope.handleCampaignPoActionsExportClicked = function () {
					var show = !$scope.showCampaignPoActionsDownload;
					storeService.dispatch(storeService.actionCreators.itemDrilldown.setDownloadCampaignPoActionsReport(show));
					$scope.showCampaignPoActionsDownload = show;
				};

				$scope.closeDialog = function (isInitialClose) {
					slideInModalService.closeModal(isInitialClose);
					$scope.loadAction = false;
					$scope.emptyItem = undefined;
					$scope.itemMasterData = undefined;
					if ($scope.actionScope) {
						$scope.actionsScope.$destroy();
					}
				};

				$scope.backToItemDetails = function () {
					$timeout(function () {
						$scope.sidebarOnlyMode = false;
						broadcastMrpDataReady(true, useRootCauseDateInHistory);
						w.trigger('resize');
					}, 0);
				};

				timeouts['openModel'] = $timeout(function () {
					if (!fromInlineSearch) {
						openModal();
					} else {
						startLoad();
					}
				}, 10);
			};

			$scope.$on('$destroy', function() {
				if (unsubscribe) unsubscribe();
				w.off('resize');
			});

			init();
		});

})();
